export default __webpack_public_path__ + "static/media/238.7fc46bed.jpg";